export type OrderDetailFieldProps =
  | OrderDetailFieldPropsMandatory
  | OrderDetailFieldPropsConfigurable
  | OrderDetailFieldPropsCustom;

export enum OrderDetailFieldPropsMandatory {
  OrderNumber = 'salesOrderNumber',
  PoNumber = 'clientReferenceNumber',
  OrderReferenceNumber = 'orderReferenceNumber',
}

export enum OrderDetailFieldPropsConfigurable {
  Account = 'account',
  Address = 'address',
  DatePlaced = 'orderDate',
  TotalOrderQuantity = 'quantity',
  TotalOrderValue = 'totalPriceNet',
  UpdatedDate = 'updatedDate',
}

// Custom properties to be calculated and shown
// Defined with configurable props in configuration(rule engine) for proper sorting
export enum OrderDetailFieldPropsCustom {
  TrackingDeliveryCount = 'trackingDeliveryCount',
}
